export default [{
    path: '/courses',
    name: 'courses',
    component: () =>
        import ('@/views/pages/courses/courses-list/CoursesList.vue'),
    meta: {
        pageTitle: 'Courses',
        breadcrumb: [{
            text: 'Courses',
            active: true,
            to: '/courses',
        }, ],
        resource: 'course',
        action: 'read',
    },
},
{
    path: '/courses/view/:id',
    name: 'courses-view',
    component: () =>
        import ('@/views/pages/courses/courses-view/CoursesView.vue'),
    meta: {
        pageTitle: 'View Course',
        breadcrumb: [
        {
            text: 'Courses',
            to: '/courses',
        },{
            text: 'View',
            active: true,
        } ],
        resource: 'course',
        action: 'read',
    },
},
{
    path: '/courses/edit/:id',
    name: 'courses-edit',
    component: () =>
        import ('@/views/pages/courses/courses-edit/CoursesEdit.vue'),
    meta: {
        pageTitle: 'Edit Course',
        breadcrumb: [
        {
            text: 'Courses',
            to:'/courses',
        },
        {
            text: 'Edit',
            active: true,
        } ],
        resource: 'course',
        action: 'read',
    },
},
{
    path: '/courses/add',
    name: 'courses-add',
    component: () =>
        import ('@/views/pages/courses/courses-add/CoursesAdd.vue'),
    meta: {
        pageTitle: 'Add course',
        breadcrumb: [
        {
            text: 'Courses',
            to:'/courses',
        },
        {
            text: 'Add',
            active: true,
        } ],
        resource: 'course',
        action: 'read',
    },
},
]